import { useState, ChangeEvent } from 'react';

export const useFileAttachments = () => {
  const [attachError, setAttachError] = useState<string>('');
  const [attachments, setAttachments] = useState<File[]>([]);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    setAttachError('');
    const newFiles = Array.from(e.target.files);
    const MAX_PAYLOAD_SIZE = 5 * 1024 * 1024; // 5 MB

    const currentTotal = attachments.reduce((sum, f) => sum + f.size, 0);
    const newTotal = newFiles.reduce((sum, f) => sum + f.size, 0) + currentTotal;

    if (newTotal > MAX_PAYLOAD_SIZE) return setAttachError('Total attachments size cannot exceed 5 MB.');

    setAttachments([...attachments, ...newFiles]);
  };

  return {
    attachError,
    setAttachError,
    attachments,
    setAttachments,
    handleFileChange
  };
}; 